import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const LocationService = () => {
    const getCurrentLocation = () => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('Geolocation nije podržan u ovom browseru'));
                return;
            }

            const options = {
                enableHighAccuracy: true,
                timeout: 15000, // 15 seconds
                maximumAge: 60000 // 1 minute
            };

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const location = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                        altitude: position.coords.altitude,
                        altitudeAccuracy: position.coords.altitudeAccuracy,
                        heading: position.coords.heading,
                        speed: position.coords.speed,
                        timestamp: new Date(position.timestamp).toISOString()
                    };
                    resolve(location);
                },
                (error) => {
                    reject(error);
                },
                options
            );
        });
    };

    const sendLocationError = async (errorData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/location/error`, errorData);
            return response.data;
        } catch (error) {
            console.error('Failed to send location error to server:', error);
            throw error;
        }
    };

    const saveLocationToServer = async (locationData, contextData = {}) => {
        try {
            const payload = {
                ...locationData,
                ...contextData
            };

            const response = await axios.post(`${API_BASE_URL}/location/save`, payload);
            return response.data;
        } catch (error) {
            console.error('Failed to save location to server:', error);
            throw error;
        }
    };

    return {
        getCurrentLocation,
        sendLocationError,
        saveLocationToServer
    };
};

export default LocationService;
